import { Box, Button, Stack, Typography, deepCopy } from "@compass/core";
import { useCallback, useEffect, useRef, useState } from "react";
import produce from "immer";

type TrackedItem = {
  count: number;
};

export const TestPendingChanges = () => {
  const [trackedItem, setTrackedItem] = useState<TrackedItem | undefined | null>({ count: 0 });
  const {} = usePendingChanges({ trackedItems: [trackedItem] });

  return (
    <Stack spacing="lg">
      <Box>
        <pre>{JSON.stringify(trackedItem, null, 4)}</pre>
      </Box>

      <Stack direction={"row"} spacing="sm">
        <Button
          onClick={() =>
            setTrackedItem(
              produce((draft) => {
                if (draft) draft.count += 1;
              })
            )
          }
          variant="outlined"
        >
          Increment
        </Button>

        <Button onClick={() => setTrackedItem(undefined)} variant="outlined">
          Set undefined
        </Button>

        <Button onClick={() => setTrackedItem(null)} variant="outlined">
          Set null
        </Button>

        <Button onClick={() => setTrackedItem({ count: 0 })} variant="outlined">
          Initialize
        </Button>
      </Stack>

      <Stack>
        <Typography>pendingChanges: {}</Typography>
        <Typography>Check Console.log for each button</Typography>
      </Stack>
    </Stack>
  );
};

type usePendingChangesProps = {
  trackedItems: any[] | undefined;
  handleConfirmClose?: () => void;
};
export const usePendingChanges = ({
  trackedItems,
}: usePendingChangesProps): {
  pendingChanges: boolean;
  resetPendingChanges: (trackedItems: any[] | undefined) => void;
} => {
  const [originalTrackedItems, setOriginalTrackedItems] = useState<any[] | undefined>(deepCopy(trackedItems));
  const [pendingChanges, setPendingChanges] = useState<boolean>(false);

  useEffect(() => {
    console.log("trackedItems useEffect");

    if (!pendingChanges && JSON.stringify(originalTrackedItems) !== JSON.stringify(trackedItems)) {
      setPendingChanges(true);
    }
  }, [trackedItems]);

  const resetPendingChanges = (trackedItems: any[] | undefined) => {
    setTimeout(() => {
      setPendingChanges(false);
      setOriginalTrackedItems(deepCopy(trackedItems));
    }, 50);
  };

  return {
    pendingChanges: pendingChanges,
    resetPendingChanges: (trackedItems: any[] | undefined) => resetPendingChanges(trackedItems),
  };
};
